export const perOMN = {
  O: 'Open Cover',
  M: 'Master Policy',
  N: 'None'
}

export const prtIL = {
  I: 'Immediate',
  L: 'Later'
}

export const premHdg = {
  P: 'Premium',
  A: 'As Arranged',
  R: 'Each Risk',
  M: 'Minimum',
  3: 'Takaful'
}

export const BenefitType = {
  L: 'Loading',
  D: 'Discount',
  P: 'Premium'
}

export const schemeType = {
  P: 'Personal',
  C: 'Commercial'
}

export const scrRef = {
  '01': 'Policy Level Upper Text',
  '02': 'Policy Level Memo Text',
  '03': 'Policy Level Renewal Text',
  '04': 'Policy Level Endorsement Text',
  '05': 'Policy Level Lower Text',
  '10': 'Policy Risk Group Upper Text',
  '11': 'Policy Risk Group Lower Text',
  '20': 'Risk Level Upper Text',
  '21': 'Risk Level Lower Text',
  '22': 'Risk Level Endorsemant Text',
  '30': 'Item Level Upper Text',
  '31': 'Item Level Lower Text',
  '32': 'Item Level Endorsement Text',
  '40': 'Miscellaneous Letter Text'
}

export const limType = {
  T: 'Treaty Limit',
  C: 'Company Limit'
}

// Cedant / Reinsurer
export const cedType = {
  I: 'I - Insurer',
  B: 'B - Broker'
}

// Treaty
export const acctType = {
  I: 'I - Inwards',
  O: 'O - Outwards'
}

export const propNProp = {
  P: 'P - Proportional',
  N: 'N - Non-Proportional'
}

export const ttyType = {
  // F: 'F - Facultative Obligatory',
  T: 'T - Treaty',
  W: 'W - Quota Share',
  X: 'X - Excess of Loss',
  L: 'L - Stop Loss'
}

export const clCutROff = {
  C: 'C - Clean Cut',
  R: 'R - Run Off'
}

export const basisSILim = {
  A: 'A - Any One Accident',
  C: 'C - Any One Claim',
  E: 'E - Estimated Maximum Loss',
  P: 'P - Probable Maximum Loss',
  R: 'R - Any One Risk',
  S: 'S - Sum Insured',
  T: 'T - Any One Treaty'
}

export const basisRating = {
  A: 'A - Adjustment',
  B: 'B - Burning Cost',
  F: 'F - Flat',
  N: 'N - Not Available'
}

export const procId = {
  // C201: 'C201 - New Claims Submisssion',
  // C202: 'C202 - Claims Pending Registration',
  C203: 'C203 - Claims Payment Sanction List check',
  // C620: 'C620 - Claims Acknowledgement Letter',
  // C622: 'C622 - Document Request Letter',
  // C623: 'C623 - Service Provider Appointment Letter',
  // C624: 'C624 - Offer Settlement Letter',
  // C625: 'C625 - Discharge Voucher',
  // C626: 'C626 - Subrogration Letter',
  // C627: 'C627 - Counter Guarantee Letter',
  // C628: 'C628 - 3rd Party PDPA'
  C210: 'C210 - Claims Reserve Limit',
  C211: 'C211 - Claims Payment Limit',
  C220: 'C220 - Close Claims',
  C221: 'C221 - Reopen Claims'
}

export const procIdUOI = {
  C203: 'C203 - Claims Payment Sanction List check',
  C210: 'C210 - Claims Reserve Limit',
  C211: 'C211 - Claims Payment Limit',
  C220: 'C220 - Close Claims',
  C221: 'C221 - Reopen Claims'
}

export const procType = {
  A: 'Alert/Notification',
  D: 'Document'
}

export const schedFreq = {
  D: 'D - Daily',
  W: 'W - Weekly',
  M: 'M - Monthly',
  Y: 'Y - Yearly'
}

// StmtType
export const prtForm = {
  R1: 'R1 - Quarterly',
  C1: 'C1 - PF Withdrawal',
  C2: 'C2 - PF Entry',
  R2: 'R2 - Minimum & Deposit Premium',
  R3: 'R3 - XOL Adjustment Premium'
}
export const dateType = {
  P: 'P - Accounting Period',
  A: 'A - As At'
}
export const debtType = {
  D: 'D - Debtor',
  S: 'S - Suspense',
  T: 'T - Transfer'
}

// StmtLnType
export const drCrType = {
  D: 'D - Debit',
  C: 'C - Credit',
  M: 'M - Memo'
}
export const rtnStat = {
  T: 'T - Retention',
  L: 'L - Release'
}
export const lnCatA = {
  E: 'E - Earned Premium',
  C: 'C - Commission',
  B: 'B - Brokerage',
  D: 'D - Deductions',
  P: 'P - Paid Loss',
  O: 'O - Outstanding Loss',
  X: 'X - XOL Cost or Recovery',
  Z: 'Z - Reserves Retained / Released',
  M: 'M - Minimum & Deposit Premium',
  A: 'A - Adjustment Premium',
  R: 'R - Reinstatement Premium',
  N: 'N - Not Applicable'
}
export const lnCatB = {
  W: 'W - Written Premium',
  C: 'C - Commission & Brokerage',
  D: 'D - Deductions',
  P: 'P - Paid Loss',
  O: 'O - Outstanding Loss',
  N: 'N - Not Applicable'
}

export const stmtLvl = {
  1: '1 - 100%',
  2: '2 - Reinsurer'
}

export const tgtMth = {
  1: '1 - January',
  2: '2 - February',
  3: '3 - March',
  4: '4 - April',
  5: '5 - May',
  6: '6 - June',
  7: '7 - July',
  8: '8 - August',
  9: '9 - September',
  10: '10 - October',
  11: '11 - November',
  12: '12 - December'
}

export const tgtMthLnCalc = {
  '': '0 - Blank',
  '01': '1 - January',
  '02': '2 - February',
  '03': '3 - March',
  '04': '4 - April',
  '05': '5 - May',
  '06': '6 - June',
  '07': '7 - July',
  '08': '8 - August',
  '09': '9 - September',
  '10': '10 - October',
  '11': '11 - November',
  '12': '12 - December'
}

export const srcYrMth = {
  S: 'S - Same',
  P: 'P - Previous'
}

export const srcMth = {
  S: 'S - Same',
  A: 'P - Previous'
}

export const calcMeth = {
  11: '11 - Source Lines this Transaction by Rate to Target Line (Level 1, Method 1)',
  13: '13 - Source Lines other Transaction to Target Line this Transaction (Level 1, Method 3)',
  22: '22 - Source Lines this Transaction by Rate to Target Line (Level 2, Method 1)',
  21: '21 - 100% by Share % to Reinsurer Line (Level 2, Method 2)',
  23: '23 - Source Lines other Transaction to Target Line this Transaction (Level 1, Method 3)'
}

export const totSepBusAn = {
  S: 'S - Separate Line each Business Analysis Code',
  T: 'T - Total'
}

export const interGrps = [
  { label: '10 - Agent', value: '10' },
  { label: '11 - Broker ', value: '11' },
  { label: '12 - Financial Institution', value: '12' },
  { label: '20 - Cedant/Reinsurer', value: '20' },
  { label: '25 - Direct Client', value: '25' },
  { label: '30 - Loss Adjuster', value: '30' },
  { label: '31 - Repairer', value: '31' },
  { label: '32 - Solicitor', value: '32' },
  { label: '33 - Forensic', value: '33' },
  { label: '34 - Survey Agent', value: '34' },
  { label: '35 - Settling Agent', value: '35' },
  { label: '40 - Contractor', value: '40' },
  { label: '41 - Guarantor', value: '41' },
  { label: '50 - Third Party', value: '50' },
  { label: '60 - Supplier', value: '60' },
  { label: '70 - Other', value: '70' }
]
